import { useAuth0 } from "@auth0/auth0-react";
import FullScreenSpinner from "components/spinner/full-screen-spinner";
import React, { useEffect } from "react";
import { endSession } from "util/endSession";

/**
 * Terminal destination of the 401 handler in `src/services/http.ts`.
 *
 * Until this route existed, `/logout` matched nothing and fell through to the
 * `path: "*"` catch-all, which re-mounted the private app with the dead session
 * still in place: the failing request fired again, 401'd again, and redirected
 * back here — a hard-reload loop that incremented `401_occurrences_count` on
 * every lap and never ended the session it was named after.
 *
 * Auth0's logout clears its own cache and nothing else, so the last-selected
 * merchant id used to outlive the session that chose it. A value naming a
 * merchant the agent cannot access makes the private routes request it on the
 * next boot — which is how one stale entry survived logout after logout and
 * kept re-breaking the following login. Clear it here, where the session ends.
 */
const Logout = () => {
  const { logout } = useAuth0();

  useEffect(() => {
    endSession(logout);
  }, [logout]);

  return <FullScreenSpinner />;
};

export default Logout;
